const errors = {
  generic: 'Er is helaas iets mis gegaan.',
  try_again: 'Er is iets misgegaan. Probeer het nogmaals.',

  // Auth
  login_failed: 'Er is iets misgegaan met inloggen. Probeer het nogmaals.',
  signup_failed: 'Het is niet gelukt om je aan te melden. Probeer het nogmaals.',
  session_expired: 'Je bent uitgelogd omdat je sessie is verlopen. Log opnieuw in.',

  // OAuth
  microsoft_personal_account:
    'Persoonlijke Microsoft-accounts (Hotmail/Outlook.com) worden niet ondersteund. ' +
    'Gebruik een zakelijk Microsoft 365-account of configureer SMTP met een app-wachtwoord.',
  microsoft_oauth_failed: 'Verbinding met Microsoft is mislukt. Probeer het opnieuw.',

  // Downloads
  pdf_download_failed: 'Er is iets misgegaan bij het downloaden van de PDF',
  download_failed: 'Er is iets misgegaan bij het downloaden',

  // Delete
  delete_failed: 'Er is iets misgegaan bij het verwijderen',

  // Dashboard
  dashboard_load_failed: 'Fout bij ophalen dashboard gegevens',

  // KVK
  kvk_search_failed: 'Fout bij zoeken in KVK',

  // Company
  no_company: 'Je hebt nog geen bedrijf aangemaakt.',

  // Email
  email_send_failed: 'Versturen mislukt',
  verification_email_failed: 'Er is een fout opgetreden bij het verzenden van de verificatie-e-mail',

  // Invoice
  invoice_finalise_failed: 'Er is iets misgegaan bij het definitief maken van de factuur',

  // Warnings
  not_allowed_no_company:
    'Het bezoeken van deze pagina is (nog) niet toegestaan. Vul eerst je gegevens in bij mijn onderneming.',

  // Invoice list
  select_at_least_one_invoice: 'Selecteer minimaal één factuur',
  select_at_least_one_quotation: 'Selecteer minimaal één offerte',
}

export default errors
